/**********************
 * This simple module exists to
 * 1) abstract the storing of objects into localStorage
 * 2) later harmonize the storing mechanism between this and the React Native app, so that redux components
 * can be used between them without modification
 */

 function prepare(data) { return JSON.stringify(data); }

 function reverse(data) { return JSON.parse(data); }

export default (function () {

  function set(id, data) {

    localStorage.setItem('p-' + id, prepare(data)); }

  function get(id) {
    if (!localStorage.getItem('p-' + id) ) {
      return {};
    } else {
      return reverse(localStorage.getItem('p-' + id));
    }

  }


  return { set, get }

})();



// WEBPACK FOOTER //
// ./src/modules/store.js